/** @module */

/**
 * @enum {string}
 * @includevals
 */
export const sceneLocationTypes = {
    pano: 'pano',
    flat: 'flat',
};